import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const ToastItemStyled = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    a {
        cursor: pointer;
        flex: none;
        text-transform: capitalize;
        ${setFontVariant("button", colorsPalettes.sky[200])};
    }

    & + button {
        flex: none;
    }
`;

export const ToastCloseButtonStyled = styled(IconButton)`
    flex: none;
`;
